module.exports = __webpack_public_path__ + "img/dec14_02.4ec779c4.jpeg";